import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Route, Switch, Redirect} from 'react-router-dom';

import {removeAlert} from '../../store/app';
import {Alerts} from '../../components/Alerts';
import {Spinners} from '../../components/Spinners';
import AppErrorBoundary from '../../components/AppErrorBoundary';
import OnlineApplication from '../../online';
import OnlineTransaction from '../../transaction';
import ErrorPage from '../../pages/ErrorPage';

function App() {
  const dispatch = useDispatch();
  const {alerts, spinners} = useSelector(state => state.app);

  return (
    <div className="text-black text-14 font-sans">
      <div className="container px-0 py-4">
        <Alerts alerts={alerts} removeAlert={id => dispatch(removeAlert(id))} />

        <Spinners spinners={spinners} />

        <AppErrorBoundary>
          <Switch>
            {/* Error */}
            <Route exact path="/error/:errorCode?" component={ErrorPage} />

            {/* Individual application */}
            <Route
              exact
              path="/application/:uuid"
              component={OnlineApplication}
            />

            {/* Individual transaction */}
            <Route
              exact
              path="/transaction/:uuid"
              component={OnlineTransaction}
            />

            {/* Fallback, no route found */}
            <Route
              path="*"
              component={({location}) => (
                <Redirect
                  to={{
                    pathname: '/error/404',
                    state: {from: location},
                  }}
                />
              )}
            />
          </Switch>
        </AppErrorBoundary>
      </div>
    </div>
  );
}

export default App;
